import { useGetExamCenterByExamCenterCodeQuery } from '@exam-center/graphql';
import { Loading } from '@shared/components';
import { createContext, useMemo } from 'react';
import { Navigate } from 'react-router-dom';

import type { ExamCenterContextValue, ExamCenterProviderProps } from './types';

const ExamCenterContext = createContext<ExamCenterContextValue | undefined>(undefined);

export default function ExamCenterProvider(props: Readonly<ExamCenterProviderProps>) {
  const { children, examCenterCode } = props;

  const {
    data,
    loading: isLoading,
    error,
  } = useGetExamCenterByExamCenterCodeQuery({
    variables: {
      getExamCenterByExamCenterCodeInput: {
        examCenterCode,
      },
    },
    skip: !examCenterCode,
  });

  const examCenter = useMemo(() => {
    return data?.ecGetExamCenterByExamCenterCode.examCenter as ExamCenterContextValue['examCenter'];
  }, [data]);

  const contextValue: ExamCenterContextValue = useMemo(() => {
    return {
      examCenter,
    };
  }, [examCenter]);

  if (isLoading) {
    return <Loading sx={{ height: '100%' }} />;
  }

  if (error) {
    return <Navigate to='/ec-not-found' replace />;
  }

  return <ExamCenterContext.Provider value={contextValue}>{children}</ExamCenterContext.Provider>;
}

export { ExamCenterContext };
